import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {BudgetInclusionForm} from '../../models/budget';
import {formatDate} from '@angular/common';
import {Observable, take} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BudgetsService {

  constructor(private http: HttpClient) {
  }

  budgetsUrl: string = `${environment.apiUrl}/api/budgets`;
  costTypesUrl: string = `${environment.apiUrl}/api/cost-type`;

  includeBudget(budgetId: number, data: any) {
    const url = `${this.budgetsUrl}/include/${budgetId}`;

    const formData = new FormData();

    for (let i = 0; i < data.filesDTO.length; i++) {
      formData.append('files', data.filesDTO[i].document);
      delete data.filesDTO[i].document
    }

    formData.append('budgetInclusionForm', JSON.stringify(data));

    if (data.budgetResponseDate) {
      data.budgetResponseDate = formatDate(data.budgetResponseDate, 'yyyy-MM-dd', 'en-US');
    }

    return this.http.post(url, formData);
  }

  getAllCostTypes() {
    let url = `${this.costTypesUrl}`;
    return this.http.get(url);
  }

  getBudgetDetails(budgetId: number) {
    let url = `${this.budgetsUrl}/details/${budgetId}`;
    return this.http.get(url);
  }

  approveBudget(budgetId: number, orderId: number): Observable<any> {
    const url = `${this.budgetsUrl}/approve/${budgetId}`;
    const params = new HttpParams().set('orderId', orderId.toString());
    return this.http.put(url, {}, { params });
}

  downloadFile(fileId: any) {
    return this.http.get(`${this.budgetsUrl}/download/${fileId}`, {responseType: 'blob'})
  }

  updateBudgetStatusToNoResponse(budgetId: number) {
    const url = `${this.budgetsUrl}/no-response/${budgetId}`;
    return this.http.put(url, {});
  }

}
